import { render, staticRenderFns } from "./MadeWithLove.vue?vue&type=template&id=a1b5f200&scoped=true"
import script from "./MadeWithLove.js?vue&type=script&lang=js&external"
export * from "./MadeWithLove.js?vue&type=script&lang=js&external"
import style0 from "./MadeWithLove.scss?vue&type=style&index=0&id=a1b5f200&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b5f200",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default})
